<template>
  <v-list-item>
    <div class="time-container">
      <div class="time-input ml-2 mr-2">
        <v-menu :close-on-content-click="false" max-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="formattedStart"
              v-bind="attrs"
              v-on="on"
              class="shrink"
              format="ampm"
            >
            </v-text-field>
          </template>

          <v-time-picker
            v-on:change="updateStart"
            :value="start"
            @click:hour="updateStartHour"
            @update:period="updateStartPeriod"
          >
          </v-time-picker>
        </v-menu>
      </div>

      <div class="time-separator">
        <v-icon>
          mdi-arrow-right
        </v-icon>
      </div>

      <div class="time-input  ml-2">
        <v-menu :close-on-content-click="false" max-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="formattedEnd"
              v-bind="attrs"
              v-on="on"
              class="shrink"
              format="ampm"
            >
            </v-text-field>
          </template>

          <v-time-picker
            v-on:change="updateEnd"
            :value="end"
            @click:hour="updateEndHour"
            @update:period="updateEndPeriod"
          >
          </v-time-picker>
        </v-menu>
      </div>
    </div>
    <div class="time-options">
      <v-btn icon color="red" @click="removeTime">
        <v-icon>
          mdi-close-circle
        </v-icon>
      </v-btn>
      <v-btn v-if="last" icon color="green" @click="addTime">
        <v-icon>
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </div>
  </v-list-item>
</template>

<script>
export default {
  name: "ScheduleItem",
  props: ["start", "end", "last"],
  computed: {
    formattedStart() {
      return this.formatTimeString(this.start);
    },
    formattedEnd() {
      return this.formatTimeString(this.end);
    }
  },
  methods: {
    formatTimeString(time) {
      const [hStr, mStr] = time.split(":");
      const hours = parseInt(hStr);

      let formattedHours = hours;
      if (formattedHours === 0) formattedHours = 12;
      if (formattedHours > 12) formattedHours -= 12;

      return `${formattedHours}:${mStr} ${hours > 11 ? "pm" : "am"}`;
    },
    updateStartHour(h) {
      const [, mStr] = this.start.split(":");
      this.updateStart(`${h}:${mStr}`);
    },
    updateStart(u) {
      this.$emit("update-start", u);
    },
    updateStartPeriod(p) {
      const [hStr, mStr] = this.end.split(":");
      let hours = parseInt(hStr);

      if (p === "am" && hours >= 12) {
        hours -= 12;
      } else if (p === "pm" && hours < 12) {
        hours += 12;
      }

      this.updateStart(`${hours}:${mStr}`);
    },
    updateEndHour(h) {
      const [, mStr] = this.end.split(":");
      this.updateEnd(`${h}:${mStr}`);
    },
    updateEndPeriod(p) {
      const [hStr, mStr] = this.end.split(":");
      let hours = parseInt(hStr);

      if (p === "am" && hours >= 12) {
        hours -= 12;
      } else if (p === "pm" && hours < 12) {
        hours += 12;
      }

      this.updateEnd(`${hours}:${mStr}`);
    },
    updateEnd(u) {
      this.$emit("update-end", u);
    },
    addTime() {
      this.$emit("add-time");
    },
    removeTime() {
      this.$emit("remove-time");
    }
  }
};
</script>

<style lang="scss">
.time-container {
  width: 210px;
}

.time-container > div {
  display: inline-block;
}

.time-options {
  .v-btn {
    display: inline-block;
  }
}

.time-input {
  width: 70px;
}

.bookie-schedule-item {
  .v-list-item {
    height: 20px;
    padding-left: 0px;
    padding-right: 0px;
  }
}
</style>
